import React, { useRef, useState } from "react";
import "./DashBoard.css";
import { Outlet } from "react-router-dom";
import SideBar from "./SideBar/SideBar";
import TopBar from "./TopBar";

function DashBoard() {
  return (
    <div className="si_dashboard_layout ge3s_dashboard_border">
      <SideBar />
      <div className="si_main_content dashboard_outlet">
        <TopBar />
        <main className="si_page_canvas">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default DashBoard;
